import { createRouter, createWebHistory } from 'vue-router';

// --- Importações de Componentes ---
// (Certifique-se de que todos os caminhos estão corretos)

// Home
import Home from './pages/Home.vue';

// Hospedagem
import HospedagemRevenda from './pages/hospedagem-revenda.vue';
import HospedagemPhp from './pages/hospedagem-php.vue';
import HospedagemNode from './pages/hospedagem-node.vue';
import HospedagemSpring from './pages/hospedagem-spring.vue';
import HospedagemJava from './pages/hospedagem-java.vue';

// VPS
import HospedagemVpsLinux from './pages/hospedagem-vps-linux.vue';
import HospedagemVpsCpanel from './pages/hospedagem-vps-cpanel.vue';
import HospedagemVpsIcp from './pages/hospedagem-vps-icp.vue';

// Assinatura (Páginas de Checkout)
import AssinejaHospedagemPhp from './pages/assineja-hospedagem-p1-p12-p24-php.vue';
import AssinejaHospedagemPhpRevenda from './pages/assineja-hospedagem-p1-p12-p24-php-revenda.vue';
import AssinejaVPSLinuxDedicado from './pages/assineja-hospedagem-p1-p6-p12-vps-linux-dedicado.vue';
import AssinejaVPScPanel from './pages/assineja-hospedagem-p1-p6-p12-vps-cpanel.vue';
import AssinejaVPSICP from './pages/assineja-hospedagem-p1-p6-p12-vps-icp.vue';
import AssinejaHospedagemJava from './pages/assineja-hospedagem-p1-p6-p12-java.vue';
import AssinejaHospedagemSpring from './pages/assineja-hospedagem-p1-p6-p12-spring.vue';
import AssinejaHospedagemNodejs from './pages/assineja-hospedagem-p1-p6-p12-nodejs.vue';
import AssinejaFinalizada from './pages/assineja-finalizada.vue';
import AssinejaServerDedicado from './pages/assineja-hospedagem-p1-p6-p12-server-dedicado.vue';

// Dedicado
import HospedagemDedicado from './pages/hospedagem-dedicado.vue';

// Promoção
import HospedagemPromocao from './pages/hospedagem-promocao.vue';

// Atendimento
import Atendimento from './pages/atendimento.vue';
import AtendimentoObrigado from './pages/atendimento-obrigado.vue';

// Institucional
import Infraestrutura from './pages/infraestrutura.vue';
import SobreNos from './pages/sobre-nos.vue';
import PainelICP from './pages/painel-icp.vue';

// Políticas e Contratos
import PoliticaDeUso from './pages/politica-de-uso.vue';
import PoliticaDeSpam from './pages/politica-de-spam.vue';
import PoliticaDeLgpd from './pages/politica-de-lgpd.vue';
import ContratoHospedagem from './pages/contrato-hospedagem.vue';
import ContratoVpsDedicado from './pages/contrato-vps-dedicado.vue';
import ContratoAdministrativo from './pages/contrato-administrativo-vps-dedicado.vue';

// Layout e páginas administrativas
import AdminLayout from './admin/components/AdminLayout.vue';
import Login from './admin/views/Login.vue';
import Dashboard from './admin/views/Dashboard.vue';
import Planos from './admin/views/Planos.vue';
import Banners from './admin/views/Banner.vue';
// Lazy loading para outras páginas admin (se aplicável)
// import Destaques from './admin/views/Destaques.vue'; // Exemplo se não for lazy
// import Cupons from './admin/views/Cupons.vue';     // Exemplo se não for lazy

// --- Definição das Rotas com Meta Tags ---
const routes = [

  // --- PÁGINAS PÚBLICAS ---

  // Home
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'Integrator Host | Hospedagem Cloud, VPS e Dedicado',
      description: 'Soluções de hospedagem Cloud, VPS e Dedicado de alta performance com painel ICP exclusivo, data center no Brasil e suporte especializado.'
    }
  },

  // Hospedagem Compartilhada/Plataforma
  {
    path: '/plano-hospedagem-revenda',
    name: 'plano-hospedagem-revenda',
    component: HospedagemRevenda,
    meta: {
      title: 'Integrator Host | Revenda de Hospedagem PHP com cPanel',
      description: 'Inicie seu negócio de hospedagem com nossos planos de revenda PHP. Painel individual para clientes, recursos escaláveis e suporte.'
    }
  },
  {
    path: '/plano-hospedagem-php',
    name: 'plano-hospedagem-php',
    component: HospedagemPhp,
    meta: {
      title: 'Integrator Host | Hospedagem PHP com cPanel ',
      description: 'Planos de hospedagem PHP rápidos e seguros no Brasil. Ideal para WordPress, Laravel e outros frameworks.'
    }
  },
  {
    path: '/plano-hospedagem-node',
    name: 'plano-hospedagem-node',
    component: HospedagemNode,
    meta: {
      title: 'Integrator Host | Hospedagem Node.js ',
      description: 'Hospede suas aplicações Node.js com facilidade. Gerencie facilmente com o painel Integrator Node.js'
    }
  },
  {
    path: '/plano-hospedagem-spring',
    name: 'plano-hospedagem-spring',
    component: HospedagemSpring,
    meta: {
      title: 'Integrator Host | Hospedagem Spring Boot',
      description: 'Plataforma ideal para aplicações Java Spring Boot. Deployment simplificado, alta performance. Gerencie facilmente com o painel Integrator Spring Boot'
    }
  },
  {
    path: '/plano-hospedagem-java',
    name: 'plano-hospedagem-java',
    component: HospedagemJava,
    meta: {
      title: 'Integrator Host | Hospedagem Java',
      description: 'Hospedagem Java confiável com suporte a Tomcat, Glassfish, Jboss, Wildfly, Jetty. Ideal para aplicações web Java EE. Gerencie facilmente com o painel Integrator Java EE.'
    }
  },

  // VPS
  {
    path: '/plano-vps-linux',
    name: 'plano-vps-linux',
    component: HospedagemVpsLinux,
    meta: {
      title: 'Integrator Host | Servidor VPS Linux',
      description: 'VPS Linux com acesso root, recursos dedicados e alta performance. Escolha sua distribuição e tenha controle total.'
    }
  },
  {
    path: '/plano-vps-cpanel',
    name: 'plano-vps-cpanel',
    component: HospedagemVpsCpanel,
    meta: {
      title: 'Integrator Host | Servidor VPS cPanel',
      description: 'VPS com cPanel/WHM pré-instalado para gerenciamento fácil de sites e contas. Performance dedicada e autonomia total.'
    }
  },
  {
    path: '/plano-vps-icp',
    name: 'plano-vps-icp',
    component: HospedagemVpsIcp,
    meta: {
      title: 'Integrator Host | Servidor VPS com Painel ICP ',
      description: 'VPS poderoso com o painel de controle exclusivo ICP. Gerencie aplicações, bancos de dados e segurança com autonomia.'
    }
  },

  // Dedicado
  {
    path: '/plano-dedicado',
    name: 'plano-dedicado',
    component: HospedagemDedicado,
    meta: {
      title: 'Integrator Host | Servidor Dedicado',
      description: 'Máxima performance e recursos exclusivos com nossos Servidores Dedicados. Ideal para projetos de grande escala e alta demanda.'
    }
  },

  // Promoção
  {
    path: '/plano-promocao',
    name: 'plano-promocao',
    component: HospedagemPromocao,
    meta: {
      title: 'Integrator Host | Promoções de Hospedagem',
      description: 'Confira nossas promoções e ofertas especiais em planos de hospedagem Cloud, VPS e Dedicado. Economize agora!'
    }
  },

  // Atendimento
  {
    path: '/atendimento',
    name: 'atendimento',
    component: Atendimento,
    meta: {
      title: 'Integrator Host | Atendimento e Suporte',
      description: 'Entre em contato com nossa equipe de vendas ou suporte técnico. Tire suas dúvidas sobre nossos serviços de hospedagem.'
    }
  },
  {
    path: '/atendimento-obrigado',
    name: 'atendimento-obrigado',
    component: AtendimentoObrigado,
    meta: {
      title: 'Integrator Host | Mensagem Enviada',
      description: 'Obrigado por entrar em contato com a Integrator Host. Sua mensagem foi recebida e responderemos em breve.',
      robots: 'noindex, nofollow' // Para não indexar página de obrigado
    }
  },

  // Assinatura (Checkout Pages)
  {
    path: '/assineja-hospedagem-php',
    name: 'assineja-hospedagem-php',
    component: AssinejaHospedagemPhp,
    meta: {
      title: 'Integrator Host | Assinar Hospedagem PHP',
      description: 'Selecione o ciclo e finalize sua assinatura do plano de Hospedagem PHP.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/assineja-hospedagem-php-revenda',
    name: 'assineja-hospedagem-php-revenda',
    component: AssinejaHospedagemPhpRevenda,
    meta: {
      title: 'Integrator Host | Assinar Revenda PHP',
      description: 'Selecione o ciclo e finalize sua assinatura do plano de Revenda de Hospedagem PHP.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/assineja-server-dedicado',
    name: 'assineja-server-dedicado',
    component: AssinejaServerDedicado,
    meta: {
      title: 'Integrator Host | Assinar Server Dedicado',
      description: 'Selecione o ciclo e finalize sua assinatura do plano Server Dedicado.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/assineja-vps-linux-dedicado',
    name: 'assineja-vps-linux-dedicado',
    component: AssinejaVPSLinuxDedicado,
    meta: {
      title: 'Integrator Host | Assinar VPS Linux',
      description: 'Selecione o ciclo e finalize sua assinatura do plano VPS Linux.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/assineja-vps-icp',
    name: 'assineja-vps-icp',
    component: AssinejaVPSICP,
    meta: {
      title: 'Integrator Host | Assinar VPS com Painel ICP',
      description: 'Selecione o ciclo e finalize sua assinatura do plano VPS com Painel ICP.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/assineja-vps-cpanel',
    name: 'assineja-vps-cpanel',
    component: AssinejaVPScPanel,
    meta: {
      title: 'Integrator Host | Assinar VPS com cPanel',
      description: 'Selecione o ciclo e finalize sua assinatura do plano VPS com cPanel.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/assineja-hospedagem-java',
    name: 'assineja-hospedagem-java',
    component: AssinejaHospedagemJava,
    meta: {
      title: 'Assinar Hospedagem Java | Integrator Host',
      description: 'Selecione o ciclo e finalize sua assinatura do plano de Hospedagem Java.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/assineja-hospedagem-spring',
    name: 'assineja-hospedagem-spring',
    component: AssinejaHospedagemSpring,
    meta: {
      title: 'Integrator Host | Assinar Hospedagem Spring Boot',
      description: 'Selecione o ciclo e finalize sua assinatura do plano de Hospedagem Spring Boot.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/assineja-hospedagem-nodejs',
    name: 'assineja-hospedagem-nodejs',
    component: AssinejaHospedagemNodejs,
    meta: {
      title: 'Integrator Host | Assinar Hospedagem Node.js',
      description: 'Selecione o ciclo e finalize sua assinatura do plano de Hospedagem Node.js.',
      robots: 'noindex, nofollow'
    }
  },

  // Finaliza Pedido
  {
    path: '/assineja-finalizada',
    name: 'assineja-finalizada', 
    component: AssinejaFinalizada,
    meta: {
      title: 'Integrator Host | Pedido Concluído',
      description: 'Obrigado por escolher a Integrator Host! Seu pedido foi concluído com sucesso.',
      robots: 'noindex, nofollow' 
    }
  },

  // Institucional
  {
    path: '/infraestrutura',
    name: 'infraestrutura',
    component: Infraestrutura,
    meta: {
      title: 'Integrator Host | Infraestrutura e Data Center',
      description: 'Conheça nossa infraestrutura de ponta localizada no EUA. Alta disponibilidade, segurança e rede de baixa latência.'
    }
  },
  {
    path: '/sobre-nos',
    name: 'sobre-nos',
    component: SobreNos,
    meta: {
      title: 'Integrator Host | Sobre a Integrator Host',
      description: 'Saiba mais sobre a história, missão e valores da Integrator Host, sua parceira em soluções de hospedagem no Brasil.'
    }
  },
  {
    path: '/painel-icp',
    name: 'painel-icp',
    component: PainelICP,
    meta: {
      title: 'Integrator Host | Painel de Controle ICP',
      description: 'Conheça o ICP, nosso painel exclusivo para gerenciamento completo de hospedagem PHP, Java, Node, VPS e mais.'
    }
  },

  // Políticas e Contratos
  {
    path: '/politica-de-uso',
    name: 'politica-de-uso',
    component: PoliticaDeUso,
    meta: {
      title: 'Integrator Host | Política de Uso Aceitável',
      description: 'Consulte nossa Política de Uso Aceitável (AUP) para utilização dos serviços de hospedagem da Integrator Host.'
    }
  },
  {
    path: '/politica-de-spam',
    name: 'politica-de-spam',
    component: PoliticaDeSpam,
    meta: {
      title: 'Integrator Host | Política Anti-SPAM',
      description: 'Leia nossa política rigorosa contra o envio de SPAM a partir de nossa infraestrutura.'
    }
  },
  {
    path: '/politica-de-lgpd',
    name: 'politica-de-lgpd',
    component: PoliticaDeLgpd,
    meta: {
      title: 'Integrator Host | Política de Privacidade (LGPD)',
      description: 'Entenda como a Integrator Host trata seus dados pessoais em conformidade com a LGPD.'
    }
  },
  {
    path: '/contrato-de-hospedagem',
    name: 'contrato-de-hospedagem',
    component: ContratoHospedagem,
    meta: {
      title: 'Integrator Host | Contrato de Hospedagem',
      description: 'Termos e condições do serviço de hospedagem de sites da Integrator Host.'
    }
  },
  {
    path: '/contrato-de-vps-dedicado',
    name: 'contrato-de-vps-dedicado',
    component: ContratoVpsDedicado,
    meta: {
      title: 'Integrator Host | Contrato de Servidor VPS e Dedicado',
      description: 'Termos e condições para contratação de Servidores VPS e Dedicados.'
    }
  },
  {
    path: '/contrato-administrativo-vps-dedicado',
    name: 'contrato-administrativo-vps-dedicado',
    component: ContratoAdministrativo,
    meta: {
      title: 'Integrator Host | Contrato de Gerenciamento VPS/Dedicado',
      description: 'Termos e condições para o serviço de gerenciamento administrativo de Servidores VPS e Dedicados.'
    }
  },

  // --- ROTAS ADMINISTRATIVAS ---
  {
    path: '/integratoradm/login',
    name: 'admin-login',
    component: Login,
    meta: {
      title: 'Login Administrativo | Integrator Host',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: '/integratoradm',
    component: AdminLayout,
    meta: { requiresAuth: true, robots: 'noindex, nofollow' }, // Aplica a todas as filhas por padrão
    children: [
      {
        path: '', // Rota padrão dentro do admin
        redirect: '/integratoradm/dashboard'
        // Meta herdada do pai, incluindo requiresAuth e robots
      },
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: Dashboard,
        meta: {
          // Herda requiresAuth e robots do pai
          title: 'Dashboard | Admin Integrator Host',
        }
      },
      {
        path: 'planos',
        name: 'admin-planos',
        component: Planos,
        meta: {
          // Herda requiresAuth e robots do pai
          title: 'Gerenciar Planos | Admin Integrator Host',
        }
      },
      {
        path: 'destaques',
        name: 'admin-destaques',
        component: () => import('./admin/views/Destaques.vue'), // Usando alias @ se configurado
        meta: {
          // Herda requiresAuth e robots do pai
          title: 'Gerenciar Destaques | Admin Integrator Host',
        }
      },
      {
        path: 'cupons',
        name: 'admin-cupons',
        component: () => import('./admin/views/Cupons.vue'), // Usando alias @ se configurado
        meta: {
          // Herda requiresAuth e robots do pai
          title: 'Gerenciar Cupons | Admin Integrator Host',
        }
      },
      {
        path: 'banner',
        name: 'admin-banner',
        component: Banners,
        meta: {
          // Herda requiresAuth e robots do pai
          title: 'Gerenciar Banners | Admin Integrator Host',
        }
      }
      // Adicione outras rotas filhas do admin aqui, elas herdarão requiresAuth e robots
    ]
  },

  // --- Rota Catch-all (404 Not Found) ---
  // Deve ser a última rota
  {
    path: '/:catchAll(.*)', // Captura qualquer caminho não correspondido
    name: 'NotFound',
    component: () => import('./pages/NotFound.vue'), // Crie este componente!
    meta: {
        title: 'Integrator Host | Página não encontrada (404) ',
        description: 'A página que você tentou acessar não foi encontrada em nosso servidor.',
        robots: 'noindex'
    }
  }
];

// --- Criação da Instância do Router ---
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL), // Use BASE_URL se definido no .env
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Rola para o topo se não houver posição salva
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: 'smooth' }; // Adiciona rolagem suave
    }
  }
});

// --- Navegation Guard: Atualizador de Meta Tags (após cada navegação) ---
router.afterEach((to, from) => {
  // Usa um título padrão se a rota não tiver meta.title
  const defaultTitle = 'Integrator Host';
  document.title = to.meta.title || defaultTitle;

  // Função auxiliar para atualizar ou criar meta tags
  const setMetaTag = (name, content) => {
    let tag = document.querySelector(`meta[name="${name}"]`);
    if (content) {
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    } else if (tag) {
      // Remove a tag se o conteúdo for nulo/vazio e a tag existir
      tag.remove();
    }
  };

  // Atualiza/Cria meta description
  setMetaTag('description', to.meta.description);

  // Atualiza/Cria meta robots
  setMetaTag('robots', to.meta.robots);

  // Você pode adicionar outras meta tags aqui (ex: Open Graph)
  // setMetaTag('og:title', to.meta.ogTitle || to.meta.title || defaultTitle);
  // setMetaTag('og:description', to.meta.ogDescription || to.meta.description);
});

// --- Navegation Guard: Verificação de Autenticação (antes de cada navegação) ---
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth); // Verifica se alguma rota pai/filha requer auth

  if (requiresAuth) {
    try {
      const apiUrl = import.meta.env.VITE_API_BASE_URL;
      if (!apiUrl) {
          console.error('[Auth] VITE_API_BASE_URL não está definida!');
          // Decide o que fazer: talvez redirecionar para login ou mostrar erro
          next('/integratoradm/login'); // Redireciona como fallback
          return;
      }

      const res = await fetch(`${apiUrl}/auth/me`, {
        method: 'GET',
        credentials: 'include', // Essencial para enviar cookies de sessão
        headers: {
          'Accept': 'application/json', // Boa prática
        },
      });

      if (res.ok) {
        // Usuário autenticado, permite acesso
        next();
      } else {
        // Usuário não autenticado ou sessão expirou
        console.warn(`[Auth] Falha na verificação: Status ${res.status}`);
        // Limpa meta tags antes de redirecionar
        document.title = 'Login Administrativo | Integrator Host';
        document.querySelector('meta[name="description"]')?.remove();
        let robotsTag = document.querySelector('meta[name="robots"]');
        if (!robotsTag) {
            robotsTag = document.createElement('meta');
            robotsTag.setAttribute('name', 'robots');
            document.head.appendChild(robotsTag);
        }
        robotsTag.setAttribute('content', 'noindex, nofollow');

        next({ name: 'admin-login', query: { redirect: to.fullPath } }); // Redireciona para login, opcionalmente guardando a rota original
      }
    } catch (error) {
      console.error('[Auth] Erro de rede ou na API ao verificar autenticação:', error);
      // Limpa meta tags antes de redirecionar
      document.title = 'Login Administrativo | Integrator Host';
      document.querySelector('meta[name="description"]')?.remove();
      let robotsTag = document.querySelector('meta[name="robots"]');
        if (!robotsTag) {
            robotsTag = document.createElement('meta');
            robotsTag.setAttribute('name', 'robots');
            document.head.appendChild(robotsTag);
        }
        robotsTag.setAttribute('content', 'noindex, nofollow');
      next({ name: 'admin-login' }); // Redireciona para login em caso de erro
    }
  } else {
    // Rota não requer autenticação
    next();
  }
});

// --- Exporta a instância do Router ---
export default router;